import { FreeSlotTypeFilter } from '@/src/domains/client-booking/constants'
import type { FreeSlotTypeFilterWithAvailability } from '@/src/domains/client-booking/types'
import { DiagnosisSessionType } from '@/src/domains/diagnosis/constants'
import type { Diagnosis } from '@/src/domains/diagnosis/types'

const freeSlotTypeFilterByDiagnosisSessionType: Partial<Record<number, FreeSlotTypeFilter>> = {
  [DiagnosisSessionType.ONLINE]: FreeSlotTypeFilter.ONLINE,
  [DiagnosisSessionType.OFFLINE]: FreeSlotTypeFilter.OFFLINE,
}

export const getFreeSlotTypeFilterFromDiagnosis = (
  diagnosis: Diagnosis | undefined,
  filter: FreeSlotTypeFilterWithAvailability,
  rawFilter: string | undefined,
) => {
  const sessionType = diagnosis?.sessionType ?? undefined

  return filter === null && rawFilter === undefined && sessionType !== undefined
    ? freeSlotTypeFilterByDiagnosisSessionType[sessionType]
    : undefined
}
